import { useEffect, useState } from "react";
import { STANDARD_PACKAGE_TYPE, senderCities } from "../../data/static-data";
import Upper from "./Upper";
import SelectSenderAndReceiverRegions from "./SelectSenderAndReceiverRegions";
import Places from "./Places";
import Footer from "./Footer";
import Result from "./Result";
import { useDispatch, useSelector } from "react-redux";
import { selectCalcError, selectCalcStatus, setCalcError, setCalcStatus } from "./calcSlice";
import ContactPage from "./ContactPage";

import style from "../../sass/components/calc/calc.module.scss";
import { useTranslation } from "react-i18next";
import { pushAlert } from "../alerts/alertSlice";

const initialState = {
    "package-type": STANDARD_PACKAGE_TYPE,
    "sender-city": senderCities[0].value ?? "",
    "courier-speed": "standard",
    "receiver-country": null,
    "receiver-city": null,
    "receiver-district": null,
    "receiver-area": null,
    places: [
        {
            weight: "",
            length: "",
            width: "",
            height: "",
        },
    ],
    cost: "",
};

const CalcPage = () => {
    const {t} = useTranslation()
    const dispatch = useDispatch();
    const calcStatus = useSelector(selectCalcStatus);
    const calcError = useSelector(selectCalcError)

    const [state, setState] = useState(initialState);
    const [errors, setErrors] = useState({});
    const [showingResult, setShowingResult] = useState(false);
    const [showingContactPage, setShowingContactPage] = useState(false);
    
    const windowWidth = window.innerWidth;

    const backButtonClick = () => {
        if(showingResult) {
            setShowingResult(false);
            setShowingContactPage(false);
        }
        if(showingContactPage) {
            setShowingContactPage(false);
            setShowingResult(true);
        }
    };

    useEffect(() => {
        if (calcStatus === "fulfilled") {
            dispatch(setCalcStatus({ status: null}));
            setShowingResult(true);
        }

    }, [dispatch, calcStatus]);

    useEffect(() => {
        if(calcError) {
            dispatch(setCalcError({ error: null}));
            dispatch(pushAlert({
                type: "danger",
                message: t(calcError),
                delay: 2000,
            }))
        }
    }, [dispatch, calcError])

    return (
        <div className="relative block max-w-xl my-10 border mx-auto shadow-2xl rounded-xl">
            {/* Calculator picture */}
            <div
                className="absolute bg-emerald-600 inset-x-0 m-auto rounded-full"
                style={{ 
                    width: windowWidth < 640 ? 50 : 70, 
                    height: windowWidth < 640 ? 50 : 70, 
                    top: windowWidth < 640 ? "-25px" : "-35px"}}
            >
                <img
                    className="absolute inset-0 m-auto"
                    src="/static/images/svg/calculator.svg"
                    alt="calc"
                    width={windowWidth < 640 ? 25 : 35}
                    height={windowWidth < 640 ? 25 : 35}
                />
            </div>


            {/* Back button */}
            {(showingResult || showingContactPage) && (
                <div className="flex pl-4 pt-4">
                    <button 
                        className={`${style.btn} ${style["btn-red"]}`}
                        onClick={backButtonClick}
                    >
                    {t("calculator.back")}</button>
                </div>)}


            {/* Content */}
            <div className="p-10 sm:p-16 px-10">
                {/* calculator page */}
                <div className={(showingResult || showingContactPage) && "hidden"}>
                        <header className="mb-4 sm:mb-8">
                            <Upper state={state} setState={setState} errors={errors} />
                        </header>

                        <main className="flex flex-col gap-6 mb-4">
                            <SelectSenderAndReceiverRegions
                                state={state}
                                setState={setState}
                                errors={errors}
                            />
                            <Places state={state} setState={setState} errors={errors} />
                        </main>

                        <Footer state={state} setState={setState} setErrors={setErrors} />
                </div>
                
                {/* prices page */}
                <div className={!showingResult && "hidden"}>
                    <Result showContactPage={() => {
                        setShowingResult(false);
                        setShowingContactPage(true)
                    }} state={state} />
                </div>

                {showingContactPage &&
                    <ContactPage />
                }

            </div>
        </div>
    );
};

export default CalcPage;
